import {
  Avatar,
  Box
} from '@mui/material';
import { ActivitySectionLayout } from 'modules/components/layer32';
import React from 'react';
import * as ds from './dataService';



export type ProfileDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProfileDetailSectionProps) => {
  const { data } = ds.useQuery();
  return (

    <ActivitySectionLayout.FC
      flex='1 1 0'
      justifyContent='start'
    >
      {data.apiFileId
        ? (
          <Box
            display='flex'
            justifyContent='center'
          >
            <Box
              maxWidth='100%'
              maxHeight='18rem'
              component='img'
              borderRadius='1rem'
              src={data.url}
            />
          </Box>
        )
        : (
          <Avatar
            sx={{
              margin: 'auto',
              height: '10rem',
              width: '10rem'
            }}
          />
        )}
    </ActivitySectionLayout.FC>


  );
};
